import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControlTypeEnum} from '../../models/FormControlTypeEnum';
import {GetCustomerCategoryResponseDto} from '../../models/GetCustomerCategoryResponseDto';
import {CustomerCategoriesService} from '../../services/customer-categories.service';

@Component({
    selector: 'app-customer-categories',
    templateUrl: './customer-categories.component.html',
    styleUrls: ['./customer-categories.component.css']
})
export class CustomerCategoriesComponent implements OnInit {

    @Input()
    formControlType: FormControlTypeEnum;
    @Output()
    customerCategoryChanged = new EventEmitter<any>();

    FormControlTypeEnum = FormControlTypeEnum;
    selectedCategory: GetCustomerCategoryResponseDto;
    selectedCategories = new Array<GetCustomerCategoryResponseDto>();


    customerCategories: Array<GetCustomerCategoryResponseDto>;

    constructor(private customerCategoriesService: CustomerCategoriesService) {
        if (!this.formControlType) {
            this.formControlType = FormControlTypeEnum.Checkbox;
        }
    }

    ngOnInit() {
        this.customerCategoriesService.getAll().subscribe(data => {
            this.customerCategories = data;
            if (this.formControlType === FormControlTypeEnum.Select) {
                this.onCustomerCategoryChanged(data[0]);
            }
        });
    }

    onCustomerCategoryChanged(customerCategory: GetCustomerCategoryResponseDto) {
        this.selectedCategory = customerCategory;
        if (this.formControlType === FormControlTypeEnum.Select) {
            this.customerCategoryChanged.emit(customerCategory);
        } else if (this.formControlType === FormControlTypeEnum.Checkbox) {
            this.emitSelectedCategories(customerCategory);
        }
    }

    private emitSelectedCategories(customerCategory: GetCustomerCategoryResponseDto) {
        let index = -1;
        for (let i = 0; i < this.selectedCategories.length; i++) {
            const category = this.selectedCategories[i];
            if (customerCategory === category) {
                index = i;
                break;
            }
        }
        if (index > -1) {
            this.selectedCategories.splice(index, 1);
        } else {
            this.selectedCategories.push(customerCategory);
        }
        this.customerCategoryChanged.emit(this.selectedCategories);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/customer-categories/customer-categories.component.ts